"use client";

import { useTranslations } from "next-intl";
import { DirectionalChevron } from "@/components/core/DirectionalChevron";
import { InfiniteScroll } from "@/components/core/InfiniteScroll/InfiniteScroll";
import {
  OrderItem,
  OrderItemSkeleton,
  OrdersEmptyState,
} from "@/components/features/user-orders";
import { useFetchMyPurchases } from "@/hooks/order/useFetchMyPurchases";
import { Link } from "@/i18n/navigation";

export const RecentPurchases = () => {
  const t = useTranslations("profile");
  const query = useFetchMyPurchases({ limit: 3 });
  const { data, isLoading } = query;

  const orders = data?.pages.flatMap((page) => page?.data?.result || []) || [];

  return (
    <div>
      <div className="flex items-center justify-between px-4">
        <h3 className="text-sm font-bold">{t("hub.recentPurchasesTitle")}</h3>
        <Link
          href="/profile/orders"
          className="flex items-center gap-1 text-xs text-text-secondary hover:text-text-primary transition-colors"
        >
          <span>{t("hub.viewAll")}</span>
          <DirectionalChevron size={14} />
        </Link>
      </div>

      {isLoading && orders.length === 0 ? (
        <>
          <OrderItemSkeleton />
          <OrderItemSkeleton />
          <OrderItemSkeleton />
        </>
      ) : orders.length === 0 ? (
        <OrdersEmptyState />
      ) : (
        orders.map((order) => (
          <OrderItem key={order.id} order={order} className="border-b-0" />
        ))
      )}
      <InfiniteScroll query={query} />
    </div>
  );
};
